type FAIconProps = {
    name: string;
    className?: string;
    library: 'solid' | 'regular' | 'light';
    style?: any;
}

export const FAIcon = (props: FAIconProps) => {

    const { name, className, library, style } = props;

    return (
        <i
            className={`fa-${library} fa-${name} ${className}`}
            style={style}
        />
    );

};